const NO_VALUE_COLOR = '#9ca3af';

export interface ScanComplianceSummary {
    /** Share of scans taken on time; null before the first scan. */
    onTimePct: number | null;
    color: string;
    label: string;
    sublabel: string;
    title: string;
}

function complianceColor(pct: number): string {
    if (pct >= 90) return '#10b981';
    if (pct >= 70) return '#f59e0b';
    return '#ef4444';
}

function complianceLabel(pct: number): string {
    if (pct >= 90) return 'On Time';
    if (pct >= 70) return 'Occasional Delays';
    return 'Frequent Delays';
}

// Computed from counts rather than inverting the server's latePct to avoid rounding drift.
export function summarizeScanCompliance(
    lateCount: number,
    onTimeCount: number
): ScanComplianceSummary {
    const total = lateCount + onTimeCount;
    const onTimePct = total > 0 ? Math.round((onTimeCount / total) * 100) : null;
    return {
        onTimePct,
        color: onTimePct != null ? complianceColor(onTimePct) : NO_VALUE_COLOR,
        label: onTimePct != null ? complianceLabel(onTimePct) : '',
        sublabel: total > 0 ? `${onTimeCount} on-time · ${lateCount} late` : 'No scans yet',
        title: `${onTimeCount} on-time, ${lateCount} late`
    };
}
